module.exports = __webpack_public_path__ + "img/T1A_xh_4.49723486.png";